import { Component, inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

import { ImageUploadModalReturnData } from "../image-upload-interface";
import { AvatarUploadComponent } from "../avatarUpload/avatar-upload.component";

// an optional param can be added if component allows use of non-saved avatar
export interface DialogData {
  currentAvatar?: string;
  useTempAvatar?: boolean;
}

// To use the upload modal component, you will need the following setup in your component:
// const dialogRef = this.dialog.open(ImageUploadModalComponent)
// To retrieve the image from this uploader, use the following code:
// dialogRef.afterClosed().pipe(take(1)).subscribe(response => {
//  do stuff with your response data
// })

@Component({
  selector: "onsip-avatar-upload-modal",
  templateUrl: "./avatar-upload-modal.component.html",
  imports: [AvatarUploadComponent]
})
export class AvatarUploadModalComponent {
  private dialogRef = inject<MatDialogRef<AvatarUploadModalComponent>>(MatDialogRef);

  hasTempAvatar = false;
  currentAvatar = "";
  avatarChange: ImageUploadModalReturnData = {
    doSave: false,
    image: undefined
  };

  constructor() {
    const data = inject<DialogData>(MAT_DIALOG_DATA);

    if (data && data.currentAvatar) this.currentAvatar = data.currentAvatar;
    if (data && data.useTempAvatar) this.hasTempAvatar = data.useTempAvatar;
  }

  dialogResponse($event: ImageUploadModalReturnData): void {
    this.avatarChange = $event;
    this.dialogRef.close(this.avatarChange);
  }
}
